  document.addEventListener('DOMContentLoaded', function () {
    const sections = document.querySelectorAll('.viral-videos');

    sections.forEach(function (section) {
      const mediaItems = section.querySelectorAll('.viral-videos__media');

      mediaItems.forEach(function (media) {
        const video = media.querySelector('video');
        const button = media.querySelector('.viral-videos__play');

        if (!video || !button) return;

        media.addEventListener('click', function () {
          if (video.paused) {
            section.querySelectorAll('video').forEach(function (otherVideo) {
              if (otherVideo !== video) {
                otherVideo.pause();
              }
            });

            section.querySelectorAll('.viral-videos__media').forEach(function (otherMedia) {
              if (otherMedia !== media) {
                otherMedia.classList.remove('is-playing');
              }
            });

            video.play();
          } else {
            video.pause();
          }
        });

        video.addEventListener('play', function () {
          section.querySelectorAll('video').forEach(function (otherVideo) {
            if (otherVideo !== video) {
              otherVideo.pause();
            }
          });

          section.querySelectorAll('.viral-videos__media').forEach(function (otherMedia) {
            if (otherMedia !== media) {
              otherMedia.classList.remove('is-playing');
            }
          });

          media.classList.add('is-playing');
          button.setAttribute('aria-label', 'Pause video');
        });

        video.addEventListener('pause', function () {
          media.classList.remove('is-playing');
          button.setAttribute('aria-label', 'Play video');
        });

        video.addEventListener('ended', function () {
          media.classList.remove('is-playing');
          button.setAttribute('aria-label', 'Play video');
        });
      });
    });
  });